import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminTracks } from '../Api/AdminTracks';
import { Toast } from '../hooks/useToast';
import { updateKey } from './DefaultReducer';
import { updateTrackCounts } from './DashboardReducer';


export const fetchAdminTrackThunk = createAsyncThunk(
    'adminTracks/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await AdminTracks.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const createAdminTrackThunk = createAsyncThunk(
    'adminTracks/create',
    async ({ data, setIsSubmitted, setIsListed, setDetails }, { getState, dispatch }) => {
        try {
            dispatch(updateKey({ linkDisabled: true }))
            const { api_token } = getState().profile.data;
            const response = await AdminTracks.create({ data, api_token });
            Toast('Track Uploaded Successfully', 'success', false);
            setIsListed(true);
            setDetails({})
            dispatch(updateTrackCounts('increment'))
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err);
        }
        finally {
            setIsSubmitted(false)
            dispatch(updateKey({ linkDisabled: false }))
        }
    }
)

export const deleteAdminTracksThunk = createAsyncThunk(
    'adminTracks/delete',
    async ({ audio_slug }, { getState, dispatch }) => {
        try {
            Toast('Deleting Track', 'success', false);
            const { api_token } = getState().profile.data;
            const response = await AdminTracks.delete({ audio_slug, api_token });
            Toast('Track Deleted Successfully', 'success', false);
            dispatch(updateTrackCounts('decrement'))
            return audio_slug
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err);
        }
    }
)


const initialState = {
    status: "pending",
    data: [],
}

export const adminTracksSlice = createSlice({
    name: 'adminTracks',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
    },
    extraReducers: {
        [fetchAdminTrackThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchAdminTrackThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchAdminTrackThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [createAdminTrackThunk.fulfilled]: (state, action) => {
            state.data = [
                action.payload,
                ...state.data,
            ]
            state.status = "success"
        },
        [createAdminTrackThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [createAdminTrackThunk.rejected]: (state, action) => {
            state.status = "success"
        },
        [deleteAdminTracksThunk.fulfilled]: (state, action) => {
            state.data = state.data.filter(item => item.slug != action.payload)
            state.status = "success"
        },
        [deleteAdminTracksThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [deleteAdminTracksThunk.rejected]: (state, action) => {
            state.status = "success"
        },

    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState } = adminTracksSlice.actions

export default adminTracksSlice.reducer